import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Update } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { environment as env } from '../../../../environments/environment'
import {
  OrganizationMember,
  UserInvite
} from '../../organization-store/store/organization-member.model'

@Injectable({
  providedIn: 'root'
})
export class OrganizationMemberService {
  store: Store
  apiurl = env.organizationMembersURL
  isProd = env.production
  envName = env.envName
  version = env.versions.app
  managementUrl = env.management

  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*'
    })
  }

  constructor(public http: HttpClient) {}

  public getAllOrganizationMembersList() {
    const url = `${this.apiurl}`

    return this.http.get(this.apiurl).pipe(take(1))
  }

  getOrganizationMembers(data) {
    if (data === undefined || data === null) return null

    const kanbans: OrganizationMember[] = data as OrganizationMember[]

    return kanbans
  }
  addOrganizationMember(
    organizationMember: OrganizationMember
  ): Observable<OrganizationMember> {
    const url = `${this.apiurl}`

    return this.http
      .post<OrganizationMember>(url, organizationMember)
      .pipe(take(1))
  }

  removeOrganizationMember(organizationMemberId: string) {
    const url = `${this.apiurl}${organizationMemberId}`

    return this.http
      .delete<OrganizationMember>(url, this.httpOptions)
      .pipe(take(1))
  }
  updateOrganizationMember(
    organization: Update<OrganizationMember>
  ): Observable<OrganizationMember> {
    return this.http
      .put<OrganizationMember>(this.apiurl, organization)
      .pipe(take(1))
  }

  inviteOrganizationMember(
    email: string,
    organitzationId: string,
    role: string
  ): Observable<UserInvite> {
    const url = `${this.managementUrl}users`
    const data = {
      email: email,
      organizationId: organitzationId,
      role: role
    }
    return this.http.post<any>(url, data, this.httpOptions).pipe(take(1))
  }
  sendVerificationTicket(email: string): Observable<any> {
    const url = `${this.managementUrl}sendVerificationTicket`
    const data = {
      email: email
    }
    return this.http.post<any>(url, data).pipe(take(1))
  }

  sendVerificationEmail(email: string): Observable<any> {
    const url = `${this.managementUrl}sendVerificationEmail`
    const data = {
      email: email
    }
    return this.http.post<any>(url, data).pipe(take(1))
  }
}
